import { Address, Classification, DeliveryDateType, FunctionalAsset } from '@synergy/models';
import { fields } from '@synergy/utils';

import { Contact } from '../../../../../common/models/contact';
import { Customer } from '../../../../../common/models/customer';
import { PaymentTerm } from '../../../../../common/models/payment-term';
import { Supplier } from '../../../../../common/models/supplier';

export interface PurchaseOrderDetailOverviewFormValues {
    sendPurchaseOrder: boolean;
    currency?: string;
    responsibleContact?: Contact;
    functionalAsset?: FunctionalAsset | null;
    requireFunctionalAssets?: boolean;
    orderDate: Date;
    deliveryDate?: Date;
    deliveryDateType?: DeliveryDateType;
    title: string;

    customerAccount?: Customer;
    customerContact?: Contact;
    customerAvisoContact?: Contact;
    deliveryAddress?: Address;
    invoiceAddress?: Address;
    chargingInvoiceAddress?: Address;
    costCentre: string;
    customerOrderNumber: string;
    orderReference: string;

    supplierAccount?: Supplier;
    supplierContact?: Contact;
    paymentTerm?: PaymentTerm;
    termsOfDeliveryContent: string;
    supplierBonus: string;
    noteToSupplier: string;
    classifications: Classification[];
    supplierOfferNumber: string;

    internalNote: string;
    createdAt: Date;
}

export const purchaseOrderDetailOverviewFieldNames = fields<PurchaseOrderDetailOverviewFormValues>();
